// thanks David Walsh -> https://davidwalsh.name/detect-scrollbar-width
function measureScrollBar() {
    const scrollDiv = document.createElement('div');
    scrollDiv.className = 'scroll-bar-measure';
    Hop.$body.append(scrollDiv);
    const scrollBarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollBarWidth;
}

const POPIN_WRAPPER_Z_INDEX = 1001;
const POPIN_OFFSET = 20;
const SCROLLBAR_MEASURE = measureScrollBar();

class Popin {
    constructor($toggle) {
        this.init($toggle);
    }

    init($toggle) {
        this.$toggle = $toggle;
        this.$popin = $($toggle.attr('data-popin'));
        this.$popinWrapper = this.$toggle.closest('.popin__wrapper');
        this.placement = this.normalizedPlacementParam();
        this.hasBackdrop = this.$toggle.attr('data-backdrop') !== 'false';
        this.REMOTE_CONTROL = this.$toggle.attr('data-remote-control') !== 'true';
        this.OPENED = false;
        this.closePopin = $('.js-popin-close');

        this.listenToGlobalEvents();
        this.listenToUserAction();
    }

    normalizedPlacementParam() {
        if (!this.$toggle.attr('data-placement')) {
            return ['bottom', 'left'];
        }
        return this.$toggle.attr('data-placement').replace(' ', '').split(',');
    }

    showBackdrop() {
        this.$popinWrapper.append('<div class="popin__backdrop"></div>');
        $('.popin__backdrop').addClass('shown');
    }

    static hideBackdrop() {
        $('.popin__backdrop').remove();
    }

    changePopinZPos(zIdx = POPIN_WRAPPER_Z_INDEX) {
        this.$popinWrapper.css({zIndex: zIdx + 1});
        this.$toggle.css({zIndex: zIdx + 2});
        this.$popin.css({zIndex: zIdx + 2});
    }

    popinPositionStyles() {
        const toggleHeight = this.$toggle.outerHeight();
        const toggleWidth = this.$toggle.outerWidth();

        let top;
        let left;
        let bottom;
        let right;

        if (this.placement[0] === 'bottom') {
            top = `${toggleHeight + POPIN_OFFSET}px`;
            bottom = 'auto';
        } else if (this.placement[0] === 'top') {
            top = 'auto';
            bottom = `${toggleHeight + POPIN_OFFSET}px`;
        } else if (this.placement[0] === 'left') {
            right = `${toggleWidth + POPIN_OFFSET}px`;
            left = 'auto';
        } else if (this.placement[0] === 'right') {
            left = `${toggleWidth + POPIN_OFFSET}px`;
            right = 'auto';
        }

        if ((this.placement[0] === 'left' || this.placement[0] === 'right') && this.placement[1] === 'top') {
            top = 0;
            bottom = 'auto';
        } else if ((this.placement[0] === 'left' || this.placement[0] === 'right') && this.placement[1] === 'bottom') {
            top = 'auto';
            bottom = 0;
        } else if ((this.placement[0] === 'top' || this.placement[0] === 'bottom') && this.placement[1] === 'left') {
            left = 0;
            right = 'auto';
        } else if ((this.placement[0] === 'top' || this.placement[0] === 'bottom') && this.placement[1] === 'right') {
            left = 'auto';
            right = 0;
        }

        return {top, left, bottom, right};
    }

    popinSizeStyles() {
        const maxHeight = this.$popin.offset().top + this.$popin.height() > Hop.$win.height() ? Hop.$win.height() - this.$popin.offset().top - POPIN_OFFSET : 'auto';
        return {maxHeight};
    }

    positionPopin() {
        this.$popin.attr('data-placement', this.placement[0]).attr('data-placement-second', this.placement[1]);
        this.$popin.css(this.popinPositionStyles());
        this.$popin.find('.popin__content').css(this.popinSizeStyles());
    }

    showPopin() {
        this.$popin.trigger('popin:opening');
        Popin.hideAllOthersPopins();
        Popin.preventUserFromScrolling();
        this.changePopinZPos();
        this.hasBackdrop && this.showBackdrop();
        this.$popin.addClass('opening');
        this.positionPopin();
        this.$popin.removeClass('opening').addClass('opened');
        this.OPENED = true;
        this.$popin.trigger('popin:opened');
    }

    hidePopin() {
        this.$popin.trigger('popin:closing');
        Popin.allowUserToScroll();
        this.changePopinZPos(0);
        Popin.hideBackdrop();
        this.$popin.removeClass('opened');
        this.OPENED = false;
        this.$popin.trigger('popin:closed');
    }

    updateAriaAttributes() {
        this.$popin.attr('aria-hidden', !this.OPENED);
    }

    togglePopin(e) {
        e.preventDefault();
        this.OPENED ? this.hidePopin() : this.showPopin();
        this.updateAriaAttributes();
    }

    hidePopinIfClickOutside(e) {
        this.OPENED && $(e.target).closest('[data-popin] , .popin').length === 0 && this.hidePopin();
    }

    hidePopinIfClickEscape(e) {
        this.OPENED && e.which === 27 && this.hidePopin();
    }

    static preventUserFromScrolling() {
        Hop.$body.css({paddingRight: `${SCROLLBAR_MEASURE}px`}).addClass('popin-open');
        Hop.$htmlTag.addClass('popin-open-for-html');
    }

    static allowUserToScroll() {
        Hop.$body.removeAttr('style').removeClass('popin-open');
        Hop.$htmlTag.removeClass('popin-open-for-html');
    }

    static hideAllOthersPopins() {
        $('[data-popin]').trigger('popin:close');
    }

    listenToUserAction() {
        this.REMOTE_CONTROL && this.$toggle.on('click', this.togglePopin.bind(this));
        Hop.$body.on('click', this.hidePopinIfClickOutside.bind(this));
        Hop.$body.on('keydown', this.hidePopinIfClickEscape.bind(this));
        if (!this.OPENED) {
            this.closePopin.on('click', this.hidePopin.bind(this));
        }
    }

    listenToGlobalEvents() {
        this.$popin.on('popin:close', this.hidePopin.bind(this));
    }
}

Hop.defineModule('popin', (domRoot) => {
    $(domRoot)
        .find('[data-popin]')
        .each((idx, el) => {
            new Popin($(el));
        });
});
